/** Helps TS typings when using Promise.allSettled */
export const filterByPromiseFulfilled = <T extends unknown>(
  arr: PromiseSettledResult<T>[]
): PromiseFulfilledResult<T>[] => {
  return arr.filter(
    (res): res is PromiseFulfilledResult<T> => res.status === 'fulfilled'
  );
};
